import { PickupReceipt, Receipt, TakeOutReceipt } from "@/types/receipt";

export const isTakeOutReceipt = (receipt: Receipt): receipt is TakeOutReceipt => {
  return receipt.type === "take_out";
};

export const isPickupReceipt = (receipt: Receipt): receipt is PickupReceipt => {
  return receipt.type === "pickup";
};
